import accounts from './icons/accounts.svg';
import accountsInverted from './icons/accounts-inverted.svg';
import arrowAngle from './icons/arrow-angle.svg';
import arrowLeft from './icons/arrow-left.svg';
import arrowRight from './icons/arrow-right.svg';
import bag from './icons/bag.svg';
import bagInverted from './icons/bag-inverted.svg';
import cartProduct from './icons/cart-product.svg';
import cartService from './icons/cart-service.svg';
import cartSubscription from './icons/cart-subscription.svg';
import chevronDown from './icons/chevron-down.svg';
import chevronRight from './icons/chevron-right.svg';
import chevronUp from './icons/chevron-up.svg';
import cross from './icons/cross.svg';
import facebook from './icons/facebook.svg';
import instagram from './icons/instagram.svg';
import linkedin from './icons/linkedin.svg';
import location from './icons/location.svg';
import locationInverted from './icons/location-inverted.svg';
import menu from './icons/menu.svg';
import minus from './icons/minus.svg';
import pinterest from './icons/pinterest.svg';
import search from './icons/search.svg';
import searchInverted from './icons/search-inverted.svg';
import systemGlobe from './icons/system-globe.svg';
import twitter from './icons/twitter.svg';
import warranty from './icons/warranty.svg';
import x from './icons/x.svg';
import youtube from './icons/youtube.svg';

const icons: Record<string, string> = {
    accounts: accounts,
    'accounts-inverted': accountsInverted,
    'arrow-angle': arrowAngle,
    'arrow-left': arrowLeft,
    'arrow-right': arrowRight,
    bag,
    'bag-inverted': bagInverted,
    'cart-product': cartProduct,
    'cart-service': cartService,
    'cart-subscription': cartSubscription,
    'chevron-down': chevronDown,
    'chevron-right': chevronRight,
    'chevron-up': chevronUp,
    cross,
    facebook,
    instagram,
    linkedin,
    location,
    'location-inverted': locationInverted,
    menu,
    minus,
    pinterest,
    search,
    'search-inverted': searchInverted,
    'system-globe': systemGlobe,
    twitter,
    warranty,
    x,
    youtube,
};

export default icons;
